import _ from 'lodash'
import { ItList } from 'types/graphql'

import { LOCAL_STORAGE_VIEW_UNLOCK_KEY } from 'src/lib/constants'

export type LocalView = Pick<
  ItList,
  'updatedAt' | 'coverUrl' | 'name' | 'relationship' | 'price' | 'creator'
> & { itListId: number }

function getLocalViews(): number[] {
  const saved = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_VIEW_UNLOCK_KEY)
  ) as number[]
  return saved || []
}

export function isViewedUnlock(itListId: number): boolean {
  return getLocalViews().includes(itListId)
}

export async function saveLocalViewUnlock(itListId: number) {
  const currentState = getLocalViews()

  localStorage.setItem(
    LOCAL_STORAGE_VIEW_UNLOCK_KEY,
    JSON.stringify([itListId, ...currentState.filter((id) => id !== itListId)])
  )
}

export function resetLocalViewsUnlock() {
  localStorage.removeItem(LOCAL_STORAGE_VIEW_UNLOCK_KEY)
}
